export default __webpack_public_path__ + "static/media/increase_sales_loop.7428f5aa.gif";